import SelectorEngine from '../../utils/dom/selector-engine';
import EventHandler from '../../utils/dom/event-handler';
import FormComponent from '../FormComponent';
import Select from '../Select';
import { InputTypes, validFormElementValue } from '../../utils/validateFormElement';

class SelectComponent extends FormComponent {
	getPreselectedOption() {
		const valueField = this.data?.valueField || 'label';
		const value = this.data?.value;
		if (value === undefined || value === null || value === '') {
			return undefined;
		}
		return this.data?.options?.find((option) => option[valueField] == value);
	}

	hasPreselectedValue() {
		return !!this.getPreselectedOption();
	}

	markup(value, data, titleMarkup) {
		this.selectContainerClass = `lta-select-container-${data.id}`;
		const hasValue = this.hasPreselectedValue();
		const placeholder = data.placeholder
			? this.renderPlaceholder(data.placeholder, !hasValue)
			: this.renderPlaceholder('Please select', !hasValue);
		const selectOptions = data.options.map((option) => this.renderSelectOptions(option)).join('');
		const inputID = `lta-select-component-id-${data.id}`;
		const labelElement =
			data.titlePattern || !data.label
				? ''
				: `<label for="${inputID}" class="lta-select__label lta-text-input__label u-text-grey-lta" id="lta-select-label">${data.label}</label>`;
		const helpText = data.description || data.instructionText;
		const helpTextMarkup = helpText
			? `<div class="u-mb-1"><label for="${inputID}" class="lta-text-input__description u-text-grey-lta">${helpText}</label></div>`
			: '';
		return `<div class="lta-select-component">
						<div class="lta-select-component-title">${titleMarkup}</div>
						<div class="${this.selectContainerClass} lta-form-check-group lta-content--fields u-mb-5">
						<div class="lta-select">
						${labelElement}
						${helpTextMarkup}
						<div class="lta-text-input--error"></div>
						<div class="js-lta-select lta-select__wrapper" data-is-multiselect="false" tabindex="0">
						<select name="" id="example-two">
							${placeholder}
							${selectOptions}
						</select>
						<div class="lta-select__box u-text-grey-lta"">
							<div class="lta-select__selected" role="combobox" aria-controls="lta-select-items-example-two" aria-expanded="false" aria-haspopup="listbox" aria-labelledby="lta-select-label" aria-owns="lta-select-items-example-two" id="lta-select__selected-example-two" aria-activedescendant="">
								<span></span>
								<div class="lta-select__caret-down lta-select__caret-rotate ${hasValue ? 'u-hidden' : ''}" aria-hidden="true">
                                    <svg class="lta-icon js-lta-text-input--btn-icon" width="1rem" height="1rem" fill="currentColor" alt="caret-down-fill" aria-hidden="true">
                                    <use xlink:href="/static/images/icons/lta-icons.svg#caret-down-fill"></use>
                                    </svg>
                                </div>
                                <button type="button" class="lta-btn lta-select__clear u-p-0 ${!hasValue ? 'u-hidden' : ''}" aria-label="clear selection">
                                    <svg class="lta-icon js-lta-text-input--btn-icon" width="1rem" height="1rem" fill="currentColor" alt="close" aria-hidden="true">
                                    <use xlink:href="/static/images/icons/lta-icons.svg#close"></use>
                                    </svg>
                                </button>
							</div>
							<div class="lta-select__items-wrapper lta-select__items-wrapper--hide ${data.autoHeight ? 'lta-select__items-wrapper--auto-height' : ''}" id="lta-select-items-example-two" role="listbox">
							</div>
						</div>
						</div>
					</div>
				</div>
			<div></div>`;
	}

	renderPlaceholder(placeholder, isSelected = true) {
		const selectedAttr = isSelected ? 'selected' : '';
		return `<option value="" disabled ${selectedAttr} hidden>${placeholder}</option>`;
	}

	renderSelectOptions(option) {
		const valueField = this.data?.valueField || 'label';
		const selectOptionID = `select-question-${this.data.id}-${option.id}`;
		const selectedTag = option[valueField] == this.data?.value ? 'selected' : '';
		return `<option value="${option.id}" data-ss-id="${selectOptionID}" id="${selectOptionID}" ${selectedTag}>${option.label}</option>`;
	}

	afterRender() {
		this.selectContainerElement = SelectorEngine.findOne(`.${this.selectContainerClass}`, this._element);
		this.selectElement = SelectorEngine.findOne('.js-lta-select', this.selectContainerElement);
		this.selectComponentElement = Select.getInstance(this.selectElement) || new Select(this.selectElement);
		EventHandler.on(
			this.selectComponentElement._selectNativeElement,
			'change',
			this.selectComponentChangeHandler.bind(this)
		);

		const preselectedOption = this.getPreselectedOption();
		if (preselectedOption) {
			setTimeout(() => {
				this.selectComponentChangeHandler();
			}, 100);
		}
	}

	selectComponentChangeHandler() {
		this.selectedOptionValue = this.selectComponentElement._selectNativeElement.value;
		this.validate();

		const selectedOptionObject = this?.data.options?.find((option) => option.id == this.selectedOptionValue);
		if (selectedOptionObject) {
			const valueField = this.data?.valueField || 'label';
			this.value = {
				...selectedOptionObject,
				fieldName: this?.data.fieldName,
				value: selectedOptionObject[valueField]
			};
			if (this.value) {
				this.dependentQuestion = this.value.dependentQuestion;
			}
		}
	}

	validate() {
		const formElementData = {
			element: this.selectContainerElement,
			formElement: this.selectComponentElement._selectNativeElement,
			errorMessage: this.data.errorMessage,
			inputType: InputTypes.SELECTOR_SELECT,
			hasIcon: false
		};
		return this.data?.isOptional ? true : validFormElementValue(this.selectedOptionValue, formElementData);
	}
}
export default SelectComponent;
